import { ComponentWithAs, Text as ChakraText } from '@chakra-ui/react';

import { TextProps } from './types';

export const Text: ComponentWithAs<'p', TextProps> = ChakraText;
